import React from 'react';

import ConvertedIcon from 'assets/myLeads/converted.svg';
import LeadsIcon from 'assets/myLeads/lead.svg';
import RateIcon from 'assets/myLeads/rate.svg';
import ValueIcon from 'assets/myLeads/value.svg';

import {
  IconWrapper,
  IconWrapperImg,
  StatCard,
  StatLabel,
  StatValue,
  StatsCardsContainer,
} from './StatsCards.styles';

const StatsCards = ({ stats }) => {
  return (
    <StatsCardsContainer>
      <StatCard $type="leads">
        <IconWrapper $type="leads">
          <IconWrapperImg src={LeadsIcon} />
        </IconWrapper>
        <div>
          <StatLabel $type="leads">TOTAL LEADS</StatLabel>
          <StatValue $type="leads">{stats.totalLeads.toLocaleString()}</StatValue>
        </div>
      </StatCard>

      <StatCard $type="converted">
        <IconWrapper $type="converted">
          <IconWrapperImg src={ConvertedIcon} />
        </IconWrapper>
        <div>
          <StatLabel $type="converted">TOTAL CONVERTED</StatLabel>
          <StatValue $type="converted">{stats.totalConverted.toLocaleString()}</StatValue>
        </div>
      </StatCard>

      <StatCard $type="value">
        <IconWrapper $type="value">
          <IconWrapperImg src={ValueIcon} />
        </IconWrapper>
        <div>
          <StatLabel $type="value">TOTAL VALUE</StatLabel>
          <StatValue $type="value">{stats.totalValue}</StatValue>
        </div>
      </StatCard>

      <StatCard $type="rate">
        <IconWrapper $type="rate">
          <IconWrapperImg className="padd-left" src={RateIcon} />
        </IconWrapper>
        <div>
          <StatLabel $type="rate">CONVERSION RATE</StatLabel>
          <StatValue $type="rate">{stats.conversionRate}</StatValue>
        </div>
      </StatCard>
    </StatsCardsContainer>
  );
};

export default StatsCards;
